// extracted by mini-css-extract-plugin
export default {"Wrapper":"PortfolioAnalysisCongrats_Wrapper__iD2u1","Buttons":"PortfolioAnalysisCongrats_Buttons__5OSZn"};